import Image from "next/image";

import LogoImpact120 from "./LogoImpact120.png";

export const NumeriqueResponsableLabel = () => {
  return (
    <div className="flex flex-col">
      <div className="flex gap-3">
        <a
          href="https://www.impactfrance.eco/nos-actus/impact-40-120-2025-decouvrez-les-laureats-2025"
          aria-label="Impact 40/120 award"
          className="relative w-18 h-[86px]"
        >
          <Image
            src={LogoImpact120}
            alt="Label 120"
            className="object-contain"
            sizes="(max-width: 768px) 96px, 112px"
          />
        </a>
      </div>
    </div>
  );
};
